import React, { useState } from "react";
import { cn } from "../../lib/cn";

/**
 * Tabs - underline style.
 * @param {{value: string, label: string}[]} tabs
 * @param {string} [value] - controlled active tab value
 * @param {(value: string) => void} [onChange]
 * @param {string} [defaultValue] - initial tab when uncontrolled
 * @param {string} [className]
 */
export function Tabs({ tabs = [], value, onChange, defaultValue, className }) {
  const [internalValue, setInternalValue] = useState(defaultValue || tabs[0]?.value);
  const activeValue = value !== undefined ? value : internalValue;

  function selectTab(tabValue) {
    if (onChange) onChange(tabValue);
    else setInternalValue(tabValue);
  }

  function handleKeyDown(event, index) {
    if (event.key === "ArrowRight") {
      event.preventDefault();
      const next = tabs[(index + 1) % tabs.length];
      selectTab(next.value);
    } else if (event.key === "ArrowLeft") {
      event.preventDefault();
      const prev = tabs[(index - 1 + tabs.length) % tabs.length];
      selectTab(prev.value);
    }
  }

  return (
    <div role="tablist" className={cn("flex gap-6 border-b border-neutral-200 dark:border-neutral-800", className)}>
      {tabs.map((tab, index) => {
        const isActive = tab.value === activeValue;
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            tabIndex={isActive ? 0 : -1}
            onClick={() => selectTab(tab.value)}
            onKeyDown={(event) => handleKeyDown(event, index)}
            className={cn(
              "-mb-px border-b-2 px-1 py-2.5 text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-neutral-900",
              isActive
                ? "border-accent-500 text-neutral-900 dark:text-neutral-100 font-medium"
                : "border-transparent text-neutral-500 dark:text-neutral-400 hover:text-neutral-700 dark:hover:text-neutral-200"
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
